import React from 'react';
import { useInView } from 'react-intersection-observer';
import { Video, Mic, PenTool, Users, Layers } from 'lucide-react';

export default function Features() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section className="py-24 bg-black text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto" ref={ref}>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            <div className="mb-4">Shortmakerならバズれる</div>
            <span className="text-4xl md:text-5xl bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-500 bg-clip-text text-transparent leading-relaxed">
              <span className="hidden sm:inline">クリエイティブが楽しくなる</span>
              <span className="sm:hidden">
                クリエイティブが<br/>
                楽しくなる
              </span>
            </span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6">
            {/* AI動画生成 */}
            <div className={`bg-zinc-900 rounded-3xl p-8 transition-all duration-700 delay-100 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-blue-500/10 p-3 rounded-xl">
                  <Video className="w-6 h-6 text-blue-500" />
                </div>
                <h3 className="text-2xl font-bold">AI動画生成</h3>
              </div>
              <p className="text-gray-400">
                商品URLを入力するだけで魅力的な動画広告を生成。数クリックでカスタマイズから書き出しまで完了し、視聴者を購入者へと導きます。
              </p>
            </div>

            {/* AIアクター */}
            <div className={`bg-zinc-900 rounded-3xl p-8 transition-all duration-700 delay-200 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-purple-500/10 p-3 rounded-xl">
                  <Users className="w-6 h-6 text-purple-500" />
                </div>
                <h3 className="text-2xl font-bold">AIアクター</h3>
              </div>
              <p className="text-gray-400">
                100種類以上のリアルなAIアクターで、ブランドメッセージをパーソナルな印象で届けます。視聴者との共感を生み出し、より深い関係性を構築します。
              </p>
            </div>

            {/* 音声合成 */}
            <div className={`bg-zinc-900 rounded-3xl p-8 transition-all duration-700 delay-300 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-green-500/10 p-3 rounded-xl">
                  <Mic className="w-6 h-6 text-green-500" />
                </div>
                <h3 className="text-2xl font-bold">音声合成</h3>
              </div>
              <p className="text-gray-400">
                140種類以上の自然な音声で広告に命を吹き込みます。スクリプトライターで一から作成することも可能で、より魅力的なナレーションを実現します。
              </p>
            </div>

            {/* AIスクリプト */}
            <div className={`bg-zinc-900 rounded-3xl p-8 transition-all duration-700 delay-400 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-pink-500/10 p-3 rounded-xl">
                  <PenTool className="w-6 h-6 text-pink-500" />
                </div>
                <h3 className="text-2xl font-bold">AIスクリプト</h3>
              </div>
              <p className="text-gray-400">
                SNS投稿からチュートリアルまで、魅力的なスクリプトを簡単に生成。クリエイティブなアイデアを効果的なストーリーに変換します。
              </p>
            </div>

            {/* カスタムアクター */}
            <div className={`bg-zinc-900 rounded-3xl p-8 transition-all duration-700 delay-500 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-yellow-500/10 p-3 rounded-xl">
                  <Users className="w-6 h-6 text-yellow-500" />
                </div>
                <h3 className="text-2xl font-bold">カスタムアクター</h3>
              </div>
              <p className="text-gray-400">
                「Bring Your Own Avatar」機能で自分だけのAIアクターを作成。一貫したブランドイメージを維持しながら、時間を節約し、効果を最大化します。
              </p>
            </div>

            {/* 一括生成 */}
            <div className={`bg-zinc-900 rounded-3xl p-8 transition-all duration-700 delay-600 ${
              inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
            }`}>
              <div className="flex items-center gap-4 mb-4">
                <div className="bg-orange-500/10 p-3 rounded-xl">
                  <Layers className="w-6 h-6 text-orange-500" />
                </div>
                <h3 className="text-2xl font-bold">一括生成</h3>
              </div>
              <p className="text-gray-400">
                商品URL、スクリプト、テンプレート、AIアクターを組み合わせて複数のバリエーションを生成。パフォーマンスを最適化し、ROIを効率的に向上させます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}